import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { VehicleType } from '@app/leasing-company/shared/models/vehicle-type';
import { environment } from '@environments/environment';
import { Observable, shareReplay } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class VehicleTypeService {

  private readonly vehicleTypes$ = inject(HttpClient).get<VehicleType[]>(`${environment.apiUrl}/leasing-company/reference-data/vehicle-type`)
    .pipe(shareReplay({ bufferSize: 1, refCount: true }));

  public getVehicleTypes(): Observable<VehicleType[]> {
    return this.vehicleTypes$;
  }
}
